import Button, { ButtonProps } from '@material-ui/core/Button';
import React from 'react';
import { Theme, withStyles } from '@material-ui/core';
import { createStyles } from '@material-ui/core/styles';
import hexRgb from 'hex-rgb';

const textButtonStyles = (theme: Theme) => {
    const primaryColor = theme.palette.primary.main;
    const rgbColor = hexRgb(primaryColor);
    const hoverColor = `rgba(${rgbColor.red},${rgbColor.green},${rgbColor.blue}, 0.1)`;
    return createStyles({
        root: {
            '&:hover': {
                backgroundColor: hoverColor
            }
        }
    });
};

export const TextButton = withStyles(textButtonStyles)((props: ButtonProps) => <Button color="primary" {...props} />);

const dangerButtonStyles = (theme: Theme) => {
    const errorColor = theme.palette.error.main;
    const rgbColor = hexRgb(errorColor);
    const hoverColor = `rgba(${rgbColor.red},${rgbColor.green},${rgbColor.blue}, 0.8)`;
    return createStyles({
        root: {
            background: theme.palette.error.main,
            '&:hover': {
                backgroundColor: hoverColor
            }
        }
    });
};
export const DangerButton = withStyles(dangerButtonStyles)((props: ButtonProps) => <Button variant="contained" {...props} />);
